// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../@vue/cli-service/node_modules/css-loader/dist/cjs.js??ref--10-oneOf-3-1!../../../../@vue/cli-service/node_modules/postcss-loader/src/index.js??ref--10-oneOf-3-2!../../../../@vue/cli-service/node_modules/postcss-loader/src/index.js??ref--10-oneOf-3-3!../../../../sass-loader/dist/cjs.js??ref--10-oneOf-3-4!./VFooter.sass");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../@vue/cli-service/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2ebb8f1c", content, true, {"sourceMap":false,"shadowMode":false});